let page_schema = {
	"tiers": [
		{
			"name": "d-none",
			"type": "checkbox",
			"id": "d-none",
			"class_name": "tags",
			"child_name": "d-nones",
			"options": [
				{
					"name": "Competent Cells & Cloning",
					"id": "competent-cells-and-cloning"
				},
				{
					"name": "Chemically Competent E. coli",
					"id": "chemically-competent-e-coli"
				},
				{
					"name": "Cloning Strains",
					"id": "cloning-strains"
				},
				{
					"name": "Expression Strains",
					"id": "expression-strains"
				},
				{
					"name": "Transformation Kits & Accessories",
					"id": "transformation-kits-and-accessories"
				},
				{
					"name": "Culture Media",
					"id": "culture-media"
				},
				{
					"name": "Antibiotics & Chemicals",
					"id": "antibiotics-and-chemicals"
				},
				{
					"name": "Antibiotics Solutions",
					"id": "antibiotics-solutions"
				},
				{
					"name": "PCR Reagents & DNA Ladders",
					"id": "pcr-reagents-and-dna-ladders"
				},
				{
					"name": "ZymoTaq DNA Polymerase",
					"id": "zymotaq-dna-polymerase"
				},
				{
					"name": "DNA Ladders",
					"id": "dna-ladders"
				},
				{
					"name": "Chemicals",
					"id": "chemicals-buffers"
				},
				{
					"name": "buffers",
					"id": "buffers"
				},
				{
					"name": "magbeads",
					"id": "magbeads"
				},
			]
		},
	],
	"filters": [],
	"products": {
    "PolStar NGS Library Prep qPCR Premix (2X)": {
			"title": "PolStar NGS Library Prep qPCR Premix (2X)",
			"catalogNumbers": "E2070, E2071",
			"description": "The PolStar™ NGS Library Prep qPCR Premix produces auto-normalized libraries when paired with qPCR instruments that control PCR cycling of individual reactions based on fluorescence (e.g. iconPCR<sup>®</sup>).",
			"handle": "/products/polstar-ngs-library-prep-qpcr-premix-2x",
			"navigation_image": "https://stage.zymoresearch.com/cdn/shop/files/PolStar-1_600x.jpg?v=1785430586&width600",
			"generalIndex": "998",
			"id": "polstar-ngs-library-prep-qpcr-premix-2x",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"zymotaq-dna-polymerase"
			],
			filters: []
		},
		"Mix & Go! E.coli Transformation Kit and Buffer Set": {
			"title": "<i>Mix & Go!</i> E.coli Transformation Kit and Buffer Set",
			"catalogNumbers": "T3001, T3002",
			"description": "The <i>Mix &amp; Go!</i> <i>E. coli</i> Transformation Kit and <i>Mix &amp; Go!</i> <i>E. coli</i> Transformation Buffer Set are convenient methods for the preparation of competent <i>E. coli</i> cells for simple and highly efficient DNA transformation.",
			"handle": "/products/mix-and-go-e-coli-transformation-kit",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3002_Mix-and-Go-E-Coli-Transformation-Buffer-Set.jpg?v=1628532392&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-e-coli-transformation-kit",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
				"transformation-kits-and-accessories",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - DH5 Alpha": {
			"title": "<i>Mix & Go!</i> Competent Cells - DH5 Alpha",
			"catalogNumbers": "T3007, T3009, T3010",
			"description": "The <i>Mix &amp; Go!</i> Competent Cells -  DH5 Alpha are premade <i>E. coli</i> DH5 alpha competent cells for simple and highly efficient DNA transformation.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-dh5-alpha",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3009_Mix-and-Go-Competent-Cells---Zymo-5a.jpg?v=1650383686&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-dh5-alpha",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - Zymo 10B": {
			"title": "<i>Mix & Go!</i> Competent Cells - Zymo 10B",
			"catalogNumbers": "T3019, T3020",
			"description": "The <i>Mix &amp; Go!</i> <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-zymo-10b",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3013_Mix-and-Go-Competent-Cells---Zymo-10B.jpg?v=1650383709&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-zymo-10b",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - JM109": {
			"title": "<i>Mix & Go!</i> Competent Cells - JM109",
			"catalogNumbers": "T3003, T3005",
			"description": "The <i>Mix &amp; Go!</i> <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-jm109",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3005_Mix-and-Go-Competent-Cells---JM109.jpg?v=1650383662&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-jm109",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
			],
			filters: []
		},
		"Mix & Go! XJb (DE3) Autolysis Competent Cells": {
			"title": "<i>Mix & Go!</i> XJb (DE3) Autolysis Competent Cells",
			"catalogNumbers": "T3051",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-xjbde3-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3051_XJb_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjbde3-autolysis",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
				"expression-strains",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - HB101": {
			"title": "<i>Mix & Go!</i> Competent Cells - HB101",
			"catalogNumbers": "T3011, T3013",
			"description": "The <i>Mix &amp; Go!</i> <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-hb101",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3013_Mix-and-Go-Competent-Cells---HB101.jpg?v=1650383625&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-hb101",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
			],
			filters: []
		},
		"Mix & Go! Competent Cells - TG1": {
			"title": "<i>Mix & Go!</i> Competent Cells - TG1",
			"catalogNumbers": "T3017",
			"description": "The <i>Mix &amp; Go!</i> <i>E. coli</i> strains are premade, chemically competent cells for simple and highly efficient DNA transformation.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-tg1",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3017_Mix_20_20Go_20Competent_20Cells_20-_20TG1_20Tubes_20x10_ffbade76-8e21-4794-92e5-2d7a768d5dc8.png?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-tg1",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"cloning-strains",
			],
			filters: []
		},
		"Mix & Go! XJa (DE3) Autolysis Competent Cells": {
			"title": "<i>Mix & Go!</i> XJa (DE3) Autolysis Competent Cells",
			"catalogNumbers": "T3031",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/mix-go-competent-cells/products/mix-and-go-competent-cells-xjade3-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3031_XJa_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjade3-autolysis",
			"tags": [
				"expression-strains",
			],
			filters: []
		},
		"XJb (DE3) Autolysis Glycerol Stock": {
			"title": "XJb (DE3) Autolysis Glycerol Stock",
			"catalogNumbers": "T5051",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/xjbde3-autolysis-trade-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5051_XJb_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532420&width=600",
			"generalIndex": "998",
			"id": "xjbde3-autolysis-trade-glycerol-stock",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"expression-strains",
			],
			filters: []
		},
		"Mix & Go! XJb Autolysis Competent Cells": {
			"title": "<i>Mix & Go!</i> XJb Autolysis Competent Cells",
			"catalogNumbers": "T3041",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/mix-and-go-competent-cells-xjb-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3041_XJb_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532393&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xjb-autolysis",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"expression-strains",
			],
			filters: []
		},
		"XJb Autolysis Glycerol Stock": {
			"title": "XJb Autolysis Glycerol Stock",
			"catalogNumbers": "T5041",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/xjb-autolysis-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5041_XJb_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532396&width=600",
			"generalIndex": "998",
			"id": "xjb-autolysis-glycerol-stock",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
			],
			filters: []
		},
		"XJa Autolysis Glycerol Stock": {
			"title": "XJa Autolysis Glycerol Stock",
			"catalogNumbers": "T5021",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/xja-autolysis-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5021_XJa_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532404&width=600",
			"generalIndex": "998",
			"id": "xja-autolysis-glycerol-stock",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"expression-strains",
			],
			filters: []
		},
		"XJa (DE3) Autolysis Glycerol Stock": {
			"title": "XJa (DE3) Autolysis Glycerol Stock",
			"catalogNumbers": "T5031",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/xjade3-autolysis-glycerol-stock",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T5031_XJa_20DE3_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml.png?v=1628532406&width=600",
			"generalIndex": "998",
			"id": "xjade3-autolysis-glycerol-stock",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"expression-strains",
			],
			filters: []
		},
		"Mix & Go! XJa Autolysis Competent Cells": {
			"title": "<i>Mix & Go!</i> XJa Autolysis Competent Cells",
			"catalogNumbers": "T3021",
			"description": "While there are many cell lysis methods available to scientists, unfortunately none of these methods combine all the ideal features for simple, efficient, economical, and gentle lysis of <i>E. coli</i> cells.",
			"handle": "/collections/xj-autolysis-e-coli-strains/products/mix-and-go-competent-cells-xja-autolysis",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/T3021_XJa_20Autolysis_20-_20Glycerol_20Stock_20-_201_20ml_20x_2010.png?v=1628532405&width=600",
			"generalIndex": "998",
			"id": "mix-and-go-competent-cells-xja-autolysis",
			"tags": [
				"competent-cells-and-cloning",
				"chemically-competent-e-coli",
				"expression-strains",
			],
			filters: []
		},
		"Rattler Plating Beads": {
			"title": "Rattler Plating Beads",
			"catalogNumbers": "S1001, S1001-5, S1001-B",
			"description": "Zymo Research offers Rattler Plating Beads to save the researcher time and effort when plating bacteria or yeast.",
			"handle": "/products/rattler-plating-beads",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/S1001-Rattler-Plating-Beads.jpg?v=1628532410&width=600",
			"generalIndex": "998",
			"id": "rattler-plating-beads",
			"tags": [
				"competent-cells-and-cloning",
				"transformation-kits-and-accessories",
			],
			filters: []
		},
		"ZymoBroth": {
			"title": "ZymoBroth",
			"catalogNumbers": "M3015-100, M3015-500",
			"description": "ZymoBroth (ZB) is a specially formulated growth medium used for the preparation of highly competent E. coli cells for DNA transformation.",
			"handle": "/products/zymobroth",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M3015-100-ZymoBroth.jpg?v=1628532390&width=600",
			"generalIndex": "998",
			"id": "zymobroth",
			"tags": [
				"competent-cells-and-cloning",
				"transformation-kits-and-accessories",
				"culture-media",
			],
			filters: []
		},
		"Dual Media Set": {
			"title": "Dual Media Set",
			"catalogNumbers": "M3011",
			"description": "Although recombinant protein expression in <i>E. coli</i> has become all but routine, high level protein expression or over-expression is not always consistent and repeatable for every protein.",
			"handle": "/products/dual-media-set",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M3011_Dual-Media-Set-100-mL-EB-500-mL-OB.jpg?v=1628532386&width=600",
			"generalIndex": "998",
			"id": "dual-media-set",
			"tags": [
				"competent-cells-and-cloning",
				"culture-media",
			],
			filters: []
		},
		"Ampicillin Sodium Solution": {
			"title": "Ampicillin Sodium Solution",
			"catalogNumbers": "A1001-25, A1001-5",
			"description": "Ampicillin is a penicillin derivative that prevents bacterial cell wall synthesis.",
			"handle": "/products/ampicillin-sodium-solution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A1001-5_Ampicilin_20-_205_20mL_6c08eb72-dd8a-4974-a296-d4e805f2747c.png?v=1628532373&width=600",
			"generalIndex": "998",
			"id": "ampicillin-sodium-solution",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"antibiotics-solutions",
				"buffers"
			],
			filters: []
		},
		"Kanamycin Sulfate Solution": {
			"title": "Kanamycin Sulfate Solution",
			"catalogNumbers": "A1003-25, A1003-5",
			"description": "Kanamycin inhibits bacterial protein synthesis by binding 70S ribosomes resulting in dysfunctional translation of mRNA.",
			"handle": "/products/kanamycin-sulfate-solution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A1003-5_Kanamycin_20Sulfate_20-_205_20mL_82538928-c2f0-4e2e-b445-83fc121288f5.png?v=1628532365&width=600",
			"generalIndex": "998",
			"id": "kanamycin-sulfate-solution",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"antibiotics-solutions",
			],
			filters: []
		},
		"Chloramphenicol Solution": {
			"title": "Chloramphenicol Solution",
			"catalogNumbers": "A1002-25, A1002-5",
			"description": "Chloramphenicol inhibits bacterial protein synthesis by binding the 50S ribosomal subunit.",
			"handle": "/products/chloramphenicol-solution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A1002-5_Chloramphenicol_20-_205_20mL_8f8ab892-59aa-4db3-9dab-b34ba7cfb97f.png?v=1628532373&width=600",
			"generalIndex": "998",
			"id": "chloramphenicol-solution",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"antibiotics-solutions",
				"chemicals-buffers",
				"buffers"
			],
			filters: []
		},
		"X-GAL (5-bromo-4-chloro-3-indolyl β-D-galactopyranoside)": {
			"title": "X-GAL (5-bromo-4-chloro-3-indolyl β-D-galactopyranoside)",
			"catalogNumbers": "X1001-25, X1001-5",
			"description": "Ready-to-use sterile 2% X-GAL solution that can be added directly to your agar plates.",
			"handle": "/products/x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/X1001-5_X-Gal-20-mG.jpg?v=1628532411&width=600",
			"generalIndex": "998",
			"id": "x-gal-5-bromo-4-chloro-3-indolyl-beta-d-galactopyranoside",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"chemicals-buffers",
			],
			filters: []
		},
		"500x L-Arabinose Solution": {
			"title": "500x L-Arabinose Solution",
			"catalogNumbers": "A2001-1, A2001-10",
			"description": "Premade concentrated L-arabinose solution has been uniquely formulated for optimal induction of the bacteriophage λ endolysin protein in  XJ Autolysis <i>E.coli</i> strains, resulting in efficient cell lysis following a single freeze-thaw cycle.",
			"handle": "/products/l-arabinose-solution",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/A2001-1_Arabinose_e791a298-6dcd-468d-bc04-acb36e735060.png?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "l-arabinose-solution",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"chemicals-buffers",
				"buffers"
			],
			filters: []
		},
		"Tetracycline Hydrochloride Solution - Reagent Grade": {
			"title": "Tetracycline Hydrochloride Solution - Reagent Grade",
			"catalogNumbers": "A1004-25, A1004-5",
			"description": "Tetracycline inhibits bacterial protein synthesis by binding the 30S ribosomal subunit.",
			"handle": "/products/tetracycline-hydrochloride-solution-reagent-grade",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/a1004-5_tetracycline_hydrochloride-5ml.png?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "tetracycline-hydrochloride-solution-reagent-grade",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"antibiotics-solutions",
			],
			filters: []
		},
		"IPTG (Isopropyl-β-D-thiogalactopyranoside)": {
			"title": "IPTG (Isopropyl-β-D-thiogalactopyranoside)",
			"catalogNumbers": "I1001-25, I1001-5",
			"description": "Premade sterile 0.5 M IPTG solution that is ideal for culture media or agar plates.",
			"handle": "/products/iptg-isopropyl-b-d-thiogalactopyranoside",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/I1001-5_IPTG_205_20ml.png?v=1628532356&width=600",
			"generalIndex": "998",
			"id": "iptg-isopropyl-b-d-thiogalactopyranoside",
			"tags": [
				"competent-cells-and-cloning",
				"antibiotics-and-chemicals",
				"chemicals-buffers",
			],
			filters: []
		},
		"Expansion Broth (EB)": {
			"title": "Expansion Broth (EB)",
			"catalogNumbers": "M3012-100, M3012-500",
			"description": "Uniquely formulated Expansion Broth™ (EB™) that is used in conjunction with our Overexpression Broth™ (OB™) for consistent high level recombinant protein expression.",
			"handle": "/products/expansion-broth-eb",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M3012-100_Expansion-Broth-100-mL.jpg?v=1628532394&width=600",
			"generalIndex": "998",
			"id": "expansion-broth-eb",
			"tags": [
				"competent-cells-and-cloning",
				"culture-media",
			],
			filters: []
		},
		"Overexpression Broth(OB)": {
			"title": "Overexpression Broth(OB)",
			"catalogNumbers": "M3013-100, M3013-500",
			"description": "Uniquely formulated Overexpression Broth™ (OB™) that is used in conjunction with our Expansion Broth™ (EB™) for consistent high level recombinant protein expression.",
			"handle": "/products/overexpression-broth-ob",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M3013-100_Overexpression-Broth-100-mL.jpg?v=1628532407&width=600",
			"generalIndex": "998",
			"id": "overexpression-broth-ob",
			"tags": [
				"competent-cells-and-cloning",
				"culture-media",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase | PreMix": {
			"title": "ZymoTaq DNA Polymerase | PreMix",
			"catalogNumbers": "E2003, E2004",
			"description": "ZymoTaq PreMix is supplied as a 2X concentrated “master mix” containing all the reagents needed to perform “hot start” PCR.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2003_ZymoTaq-PreMix.jpg?v=1628532368&width=600",
			"generalIndex": "998",
			"id": "zymotaq-premix",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"zymotaq-dna-polymerase",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase | Enzyme": {
			"title": "ZymoTaq DNA Polymerase | Enzyme",
			"catalogNumbers": "E2001, E2002",
			"description": "ZymoTaq DNA Polymerase contains all the reagents needed to perform “hot-start” PCR. The inclusion of a heat-activated, thermostable DNA polymerase reduces primer dimer and nonspecific product formation that can occur during PCR.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-dna-polymerase",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2001_ZymoTaq-Polymerase.jpg?v=1628532372&width=600",
			"generalIndex": "998",
			"id": "zymotaq-dna-polymerase",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"zymotaq-dna-polymerase",
			],
			filters: []
		},
		"ZymoTaq DNA Polymerase | qPCR Premix": {
			"title": "ZymoTaq DNA Polymerase | qPCR Premix",
			"catalogNumbers": "E2054, E2055",
			"description": "ZymoTaq qPCR PreMix contains all the reagents needed to perform quantitative PCR and other molecular downstream analysis such as high-resolution melt (HRM) analysis of DNA methylation and other general real-time PCR assays.",
			"handle": "/collections/zymotaq-polymerase/products/zymotaq-qpcr-premix",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/E2054_ZymoTaq-qPCR-Premix.jpg?v=1628532408&width=600",
			"generalIndex": "998",
			"id": "zymotaq-qpcr-premix",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"zymotaq-dna-polymerase",
			],
			filters: []
		},
		"ZymoScript One-Step RT-qPCR Kit": {
			"title": "ZymoScript One-Step RT-qPCR Kit",
			"catalogNumbers": "R3014",
			"description": "ZymoScript One-Step RT-qPCR Kit is an optimized RT-qPCR kit that contains all the components for fast reverse transcription and robust qPCR amplification in a single tube. The One-Step RT-qPCR kit is compatible with both SYBR Green and TaqMan probe-based assays.",
			"handle": "/products/zymoscript-one-step-rt-qpcr-kit",
			"navigation_image": "https://files.zymoresearch.com/product-images/r3014-zymoscript_onestep_rt_qpcr_kit.jpg",
			"generalIndex": "998",
			"id": "zymoscript-one-step-rt-qpcr-kit",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"ZymoScript RT PreMix Kit": {
			"title": "ZymoScript RT PreMix Kit",
			"catalogNumbers": "R3012",
			"description": "ZymoScript RT PreMix Kit is part of the ZymoScript family together with the ZymoScript OneStep RT-qPCR Kit (R3014). ZymoScript RT PreMix is an optimized reverse transcription kit containing all the necessary components for quick and efficient cDNA synthesis.",
			"handle": "/products/zymoscript-rt-premix-kit",
			"navigation_image": "https://files.zymoresearch.com/product-images/r3012-zymoscript_rt_prexix_kit.jpg",
			"generalIndex": "998",
			"id": "zymoscript-rt-premix-kit",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"dNTP Mix": {
			"title": "dNTP Mix",
			"catalogNumbers": "D1000, D1000-1",
			"description": "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/products/dntp-mix",
			"navigation_image": "https://files.zymoresearch.com/images/D1000_dNTPs.jpg",
			"generalIndex": "998",
			"id": "dntp-mix",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"dCTP": {
			"title": "dCTP",
			"catalogNumbers": "D1020",
			"description": "PCR nucleotides and mix",
			"handle": "/products/dctp",
			"navigation_image": "https://files.zymoresearch.com/images/D1020_dCTP.jpg",
			"generalIndex": "998",
			"id": "dctp",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"dATP": {
			"title": "dATP",
			"catalogNumbers": "D1005",
			"description": "dATP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/products/datp",
			"navigation_image": "https://files.zymoresearch.com/images/D1005_dATP.jpg",
			"generalIndex": "998",
			"id": "datp",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"dTTP": {
			"title": "dTTP",
			"catalogNumbers": "D1010",
			"description": "dTTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/products/dttp",
			"navigation_image": "https://files.zymoresearch.com/images/D1010_dTTP.jpg",
			"generalIndex": "998",
			"id": "dttp",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"dGTP": {
			"title": "dGTP",
			"catalogNumbers": "D1015",
			"description": "dGTP solution for use in nucleotide mixes, PCR, RT-PCR, library preps, etc.",
			"handle": "/products/dgtp",
			"navigation_image": "https://files.zymoresearch.com/images/D1015_dGTP.jpg",
			"generalIndex": "998",
			"id": "dgtp",
			"tags": ["pcr-reagents-and-dna-ladders"],
			filters: []
		},
		"ZR 50 bp DNA Marker": {
			"title": "ZR 50 bp DNA Marker",
			"catalogNumbers": "M5001-200, M5001-50, M5004-50",
			"description": "The ZR DNA Markers are defined DNA size fragments that encompass a range of sizes from 50 bp up to 10 kb.",
			"handle": "/collections/zr-dna-markers/products/zr-50-bp-dna-marker",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M5001-50_ZR-50-bp-DNA-Marker-50-ug.jpg?v=1628532373&width=600",
			"generalIndex": "998",
			"id": "zr-50-bp-dna-marker",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"dna-ladders",
			],
			filters: []
		},
		"ZR 100 bp DNA Marker": {
			"title": "ZR 100 bp DNA Marker",
			"catalogNumbers": "M5002-200, M5002-50, M5005-50",
			"description": "The ZR DNA Markers are defined DNA size fragments that encompass a range of sizes from 50 bp up to 10 kb.",
			"handle": "/collections/zr-dna-markers/products/zr-100-bp-dna-marker",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M5002-200_ZR_20100_20bp_20DNA_20Marker_20-_20200_20ug.png?v=1628532369&width=600",
			"generalIndex": "998",
			"id": "zr-100-bp-dna-marker",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"dna-ladders",
			],
			filters: []
		},
		"ZR 1 kb DNA Marker": {
			"title": "ZR 1 kb DNA Marker",
			"catalogNumbers": "M5003-200, M5003-50, M5006-50",
			"description": "The ZR DNA Markers are defined DNA size fragments that encompass a range of sizes from 50 bp up to 10 kb.",
			"handle": "/collections/zr-dna-markers/products/zr-1-kb-dna-marker",
			"navigation_image": "https://cdn.shopify.com/s/files/1/0548/8830/0722/products/M5003-50_ZR-1-kb-DNA-Marker-50-ug.jpg?v=1628532358&width=600",
			"generalIndex": "998",
			"id": "zr-1-kb-dna-marker",
			"tags": [
				"pcr-reagents-and-dna-ladders",
				"dna-ladders",
			],
			filters: []
		},
		"5-Fluoroorotic Acid (5-FOA)": {
			"title": "5-Fluoroorotic Acid (5-FOA)",
			"catalogNumbers": "F9001-1, F9001-5, F9003",
			"description": "Using 5-Fluoroorotic Acid (5-FOA) for the counter-selection of yeast is a common genetic screening method.",
			"handle": "/products/5-fluoroorotic-acid",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/F9001-1_5-Fluoroorotic-Acid-1-g_f35b2afb-1fd8-415e-955a-8a76343c4571_600x.jpg",
			"generalIndex": "998",
			"id": "5-fluoroorotic-acid",
			"tags": [
				"chemicals-buffers",
				"buffers"
			],
			filters: []
		},
		"His-Affinity Gel": {
			"title": "His-Affinity Gel",
			"catalogNumbers": "P2003-2",
			"description": "Nickel affinity gel used for the purification of histidine-tagged proteins.",
			"handle": "/products/his-affinity-gel",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/P2003-2_His-Affinity-Gel-14-mL_600x.jpg",
			"generalIndex": "998",
			"id": "his-affinity-gel",
			"tags": [
				"chemicals-buffers",
			],
			filters: []
		},
		"EZ-Methylation Magprep Beads": {
			"title": "EZ-Methylation Magprep Beads",
			"catalogNumbers": "D4100-5-4, D4100-5-8, D4100-5-16",
			"description": "EZ-Methylation Magprep Beads for use with Zymo Research magnetic bead-based purification kits. Sold separately or as part of a complete magnetic bead purification kit.",
			"handle": "/products/ez-methylation-magprep-beads",
			"navigation_image": "https://files.zymoresearch.com/product-images/d4100-2-3_magbinding_beads-3_ml.png",
			"generalIndex": "998",
			"id": "ez-methylation-magprep-beads",
			"tags": [
				"buffers",
				"magbeads"
			],
			filters: []
		},
		"Mix & Go! 2X Stock Competent Buffer": {
			"title": "<I>Mix &amp; Go!</i> 2X Stock Competent Buffer",
			"catalogNumbers": "T3001-3-10, T3001-3-30",
			"description": "Mix & Go! 2X Stock Competent Buffer is designed to be used with our Mix & Go! E. coli Transformation Kit and Buffer Set.",
			"handle": "/products/mix-and-go-2x-stock-competent-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/T3001-3-30_Competent-Buffer-2x-30-mL.jpg",
			"generalIndex": "998",
			"id": "mix-and-go-2x-stock-competent-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Mix & Go! 2X Stock Wash Buffer": {
			"title": "<i>Mix &amp; Go!</i> 2X Stock Wash Buffer",
			"catalogNumbers": "T3001-2-10, T3001-2-30",
			"description": "Mix & Go! 2X Wash Buffer is designed to be used with our Mix & Go! E. coli Transformation Kit and Buffer Set.",
			"handle": "/products/mix-and-go-2x-stock-wash-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/T3001-2-30_Wash-Buffer-2x-30-mL.jpg",
			"generalIndex": "998",
			"id": "mix-and-go-2x-stock-wash-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Mix & Go! Dilution Buffer": {
			"title": "<i>Mix &amp; Go!</i> Dilution Buffer",
			"catalogNumbers": "T3001-4-20, T3001-4-60",
			"description": "Mix & Go! Dilution Buffer is designed to be used with our Mix & Go! E. coli Transformation Kit and Buffer Set.",
			"handle": "/products/mix-and-go-dilution-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/T3001-4-60_Dilution-Buffer-60-mL.jpg",
			"generalIndex": "998",
			"id": "mix-and-go-dilution-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-16S  Primer Set V1-V2": {
			"title": "<i>Quick</i>-16S  Primer Set V1-V2",
			"catalogNumbers": "D6405-1-400",
			"description": "Dramatically improves the coverage for common human-associated microbes, especially pathogens, compared to commonly-used primer sets.",
			"handle": "/products/quick-16s-primer-set-v1-v2",
			"navigation_image": "https://files.zymoresearch.com/images/D6405-1-400_Quick-16S-Primer-Set-V1-V2.jpg",
			"generalIndex": "998",
			"id": "quick-16s-primer-set-v1-v2",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-16S  Primer Set V3-V4": {
			"title": "<i>Quick</i>-16S  Primer Set V3-V4",
			"catalogNumbers": "D6405-2-400",
			"description": "Compared to commonly-used primer sets, improves the coverage of several bacterial phyla and adds broad coverage for the Archaea domain.",
			"handle": "/products/quick-16s-primer-set-v3-v4",
			"navigation_image": "https://files.zymoresearch.com/images/D6405-2-400_Quick-16S-Primer-Set-V3-V4.jpg",
			"generalIndex": "998",
			"id": "quick-16s-primer-set-v3-v4",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-cfDNA Serum & Plasma Buffer Set": {
			"title": "<i>Quick</i>-cfDNA Serum & Plasma Buffer Set",
			"catalogNumbers": "D4076-A",
			"description": "Component set for use with the <i>Quick</i>-cfDNA Serum & Plasma Kit",
			"handle": "/products/quick-cfdna-serum-plasma-buffer-set",
			"navigation_image": "https://files.zymoresearch.com/product-images/D4076-A-Quick-cfDNA Serum & Plasma Kit .png",
			"generalIndex": "998",
			"id": "quick-cfdna-serum-plasma-buffer-set",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-cfDNA/cfRNA Binding Buffer": {
			"title": "<i>Quick</i>-cfDNA/cfRNA Binding Buffer",
			"catalogNumbers": "R1072-2-150",
			"description": "A component for the <i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
			"handle": "/products/quick-cfdna-cfrna-binding-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/R1072-2-150_Quick-cfDNA-cfRNA Binding Buffer-150 mL.png",
			"generalIndex": "998",
			"id": "quick-cfdna-cfrna-binding-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-cfDNA/cfRNA Digestion Buffer": {
			"title": "<i>Quick</i>-cfDNA/cfRNA Digestion Buffer",
			"catalogNumbers": "R1072-1-150",
			"description": "A component for the <i>Quick</i>-cfDNA/cfRNA Serum & Plasma Kit",
			"handle": "/products/quick-cfdna-cfrna-digestion-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/R1072-1-150_Quick-cfDNA-cfRNA-Digestion-Buffer-150-mL.jpg",
			"generalIndex": "998",
			"id": "quick-cfdna-cfrna-digestion-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-cfRNA Binding Buffer": {
			"title": "<i>Quick</i>-cfRNA Binding Buffer",
			"catalogNumbers": "R1059-4-100",
			"description": "A component for <i>Quick</i>-cfRNA Serum & Plasma Kit",
			"handle": "/products/quick-cfrna-binding-buffer",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/R1059-4-100_Quick-cfRNA-Binding-Buffer---100-mL_600x.jpg",
			"generalIndex": "998",
			"id": "quick-cfrna-binding-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-cfRNA Digestion Buffer": {
			"title": "<i>Quick</i>-cfRNA Digestion Buffer",
			"catalogNumbers": "R1059-3-50",
			"description": "A component for <i>Quick</i>-cfRNA Serum & Plasma Kit",
			"handle": "/products/quick-cfrna-digestion-buffer",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/R1059-3-50_Quick-cfRNA-Digestion-Buffer---50-mL_600x.jpg",
			"generalIndex": "998",
			"id": "quick-cfrna-digestion-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Quick-DNA MagBinding Buffer": {
			"title": "<i>Quick</i>-DNA MagBinding Buffer",
			"catalogNumbers": "D4077-1-150, D4077-1-250",
			"description": "Buffer component for use with Zymo Research purification products.",
			"handle": "/products/quick-dna-magbinding-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/D4077-1-150_Quick-DNA-MagBinding-Buffer-150-ml.jpg",
			"generalIndex": "998",
			"id": "quick-dna-magbinding-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"10X ELISA Buffer": {
			"title": "10X ELISA Buffer",
			"catalogNumbers": "D5425-2-30, D5425-2-60",
			"description": "For use with Zymo Research purification products.",
			"handle": "/products/10x-elisa-buffer",
			"navigation_image": "https://files.zymoresearch.com/product-images/D5425-2-30_10X ELISA Buffer - 30 mL .png",
			"generalIndex": "998",
			"id": "10x-elisa-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		// "2X Reaction-Lite PreMix": {
		// 	"title": "2X Reaction-Lite PreMix",
		// 	"catalogNumbers": "D5311-1, D5311-2",
		// 	"description": "For use in the OneStep qMethyl-Lite Kit",
		// 	"handle": "/products/2x-reaction-lite-premix",
		// 	"navigation_image": "https://files.zymoresearch.com/product-images/D5311-1_2X Reaction Premix - 500 uL.png",
		// 	"generalIndex": "998",
		// 	"id": "2x-reaction-lite-premix",
		// 	"tags": [
		// 		"buffers"
		// 	],
		// 	filters: []
		// },
		"2X Reaction PreMix": {
			"title": "2X Reaction PreMix",
			"catalogNumbers": "D5310-1, D5310-2",
			"description": "For use in the OneStep qMethyl Kit",
			"handle": "/products/2x-reaction-premix",
			"navigation_image": "https://files.zymoresearch.com/product-images/D5310-1_ 2X Test Reaction Premix 2x - 500 uL.png",
			"generalIndex": "998",
			"id": "2x-reaction-premix",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"5M NaCl": {
			"title": "5M NaCl",
			"catalogNumbers": "D5210-7-1",
			"description": "5 M NaCl is designed to be used with our Zymo-Spin ChIP Kit.",
			"handle": "/products/5m-nacl",
			"navigation_image": "https://files.zymoresearch.com/images/D5210-7-1_5M-NaCl-1-mL.jpg",
			"generalIndex": "998",
			"id": "5m-nacl",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"5-mC Coating Buffer": {
			"title": "5-mC Coating Buffer",
			"catalogNumbers": "D5325-1-15, D5325-1-30",
			"description": "For use with Zymo Research 5mc DNA ELISA kits",
			"handle": "/products/5-mc-coating-buffer",
			"navigation_image": "https://files.zymoresearch.com/product-images/D5325-1-15_5-mC Coating Buffer - 15 mL.png",
			"generalIndex": "998",
			"id": "5-mc-coating-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"5-mC ELISA Buffer": {
			"title": "5-mC ELISA Buffer",
			"catalogNumbers": "D5325-2-250",
			"description": "For use with Zymo Research 5mc DNA ELISA kits",
			"handle": "/products/5-mc-elisa-buffer",
			"navigation_image": "https://files.zymoresearch.com/product-images/D5325-2-250_5-mC ELISA Buffer - 250 ml.png",
			"generalIndex": "998",
			"id": "5-mc-elisa-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"5X Chromatin Elution Buffer": {
			"title": "5X Chromatin Elution Buffer",
			"catalogNumbers": "D5210-6-10",
			"description": "Used for processing samples for chromatin immunoprecipitation (ChIP) in the Zymo-Spin ChIP Kit.",
			"handle": "/products/5x-chromatin-elution-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/D5210-6-10_5X-Chromatin-Elution-Buffer-10-mL.jpg",
			"generalIndex": "998",
			"id": "5x-chromatin-elution-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"5X MN Stop Buffer": {
			"title": "5X MN Stop Buffer",
			"catalogNumbers": "D5220-4",
			"description": "Used in the EZ Nucleosomal DNA Prep Kit to stop micrococcal nuclease reaction and prepare for nucleosomal DNA purification.",
			"handle": "/products/5x-mn-stop-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/D5220-4_5X-MN-Stop-Buffer-6-mL.jpg",
			"generalIndex": "998",
			"id": "5x-mn-stop-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"7X Lysis Buffer (Blue)": {
			"title": "7X Lysis Buffer (Blue)",
			"catalogNumbers": "D4036-1-6, D4036-1-12, D4036-1-30, D4036-1-48, D4036-1-60",
			"description": "7X Lysis Buffer (Blue) is designed to be used with our Zyppy Plasmid Miniprep Kit, which uses a pellet-free modified alkaline lysis method to isolate ultra-pure plasmid DNA from E. coli in only 8 minutes.",
			"handle": "/products/7x-lysis-buffer-blue",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4036-1-48_7X-Lysis-Buffer-Blue---48-mL_644da968-5aa5-4889-bf5f-46475edb9907_600x.jpg",
			"generalIndex": "998",
			"id": "7x-lysis-buffer-blue",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"ADB (Agarose Dissolving Buffer)": {
			"title": "ADB (Agarose Dissolving Buffer)",
			"catalogNumbers": "D4001-1-50, D4001-1-100",
			"description": "Agarose Dissolving Buffer is designed for use in the Zymoclean family of products. This buffer dissolves agarose gel slices for the recovery of DNA and facilitates efficient DNA binding and subsequent recovery.",
			"handle": "/products/adb-agarose-dissolving-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/D4001-1-100_ADB-100-ml.jpg",
			"generalIndex": "998",
			"id": "adb-agarose-dissolving-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"a-Factor Mating Pheromone": {
			"title": "a-Factor Mating Pheromone",
			"catalogNumbers": "Y1004-500",
			"description": "Convenient aqueous solution for arresting yeast in G1 of the cell cycle. Opposite to the alpha-factor mating pheromone.",
			"handle": "/products/a-factor-mating-pheromone",
			"navigation_image": "https://files.zymoresearch.com/images/Y1004_a-Factor-Mating-Pheromone-A-Factor-500-ul.jpg",
			"generalIndex": "998",
			"id": "a-factor-mating-pheromone",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Alpha-Factor Mating Pheromone": {
			"title": "Alpha-Factor Mating Pheromone",
			"catalogNumbers": "Y1001",
			"description": "Convenient aqueous solution for arresting yeast in G1 of the cell cycle.",
			"handle": "/products/alpha-factor-mating-pheromone",
			"navigation_image": "https://files.zymoresearch.com/images/Y1001_Alpha-Factor-Mating-Pheromone.jpg",
			"generalIndex": "998",
			"id": "alpha-factor-mating-pheromone",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Anti-DNA HRP Antibody (100X)": {
			"title": "Anti-DNA HRP Antibody (100X)",
			"catalogNumbers": "D5425-3-100, D5425-3-200",
			"description": "For use with Zymo Research ELISA products",
			"handle": "/products/anti-dna-hrp-antibody-100x",
			"navigation_image": "https://files.zymoresearch.com/product-images/D5425-3-100_Anti-DNA HRP Antibody - 100X - 100ul.png",
			"generalIndex": "998",
			"id": "anti-dna-hrp-antibody-100x",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Bacterial DNA Standards and No Template Control": {
			"title": "Bacterial DNA Standards and No Template Control",
			"catalogNumbers": "E2006-2",
			"description": "For use with Zymo Research products.",
			"handle": "/products/bacterial-dna-standards-and-no-template-control",
			"navigation_image": "https://files.zymoresearch.com/images/E2006-2_Femto-Bacterial-DNA-Standards-and-No-Template-Control.jpg",
			"generalIndex": "998",
			"id": "bacterial-dna-standards-and-no-template-control",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"BashingBead Buffer": {
			"title": "BashingBead Buffer",
			"catalogNumbers": "D6001-3-40, D6001-3-150",
			"description": "Buffer component for use with Zymo Research purification products.",
			"handle": "/products/bashingbead-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/D6001-3-150_Bashing-Bead-Buffer_150-mL.jpg",
			"generalIndex": "998",
			"id": "bashingbead-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"BioFluid & Cell Buffer (Red)": {
			"title": "BioFluid & Cell Buffer (Red)",
			"catalogNumbers": "D4068-1-12, D4068-1-25, D4068-1-45",
			"description": "BioFluid & Cell Buffer (Red) is designed to be used with the Quick-DNA Plus system for the Proteinase K digestion of biological fluids and cells (i.e. blood, semen, buffy coat, saliva, body fluids, milk, etc).",
			"handle": "/products/biofluid-cell-buffer-red",
			"navigation_image": "https://www.zymoresearch.com/cdn/shop/products/D4068-1-25_BioFluid-_-Cell-Buffer---25-mL_600x.jpg",
			"generalIndex": "998",
			"id": "biofluid-cell-buffer-red",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Buffer P1 (Red)": {
			"title": "Buffer P1 (Red)",
			"catalogNumbers": "D4027-1-10, D4027-1-20, D4027-1-80, D4027-1-160, D4027-1-320, D4027-1-500",
			"description": "Buffer P1 (Red) is designed to be used with our ZR Plasmid Miniprep - Classic kit, which is used to efficiently isolate ultra-pure plasmid DNA from E. coli using Zymo-Spin column purification technology.",
			"handle": "/products/buffer-p1-red",
			"navigation_image": "https://files.zymoresearch.com/images/D4027-1-80_Buffer-P1-80-mL.jpg",
			"generalIndex": "998",
			"id": "buffer-p1-red",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Buffer P3  (Yellow)": {
			"title": "Buffer P3  (Yellow)",
			"catalogNumbers": "D4027-3-12, D4027-3-50, D4027-3-220, D4027-3-440",
			"description": "Buffer P3 (Yellow) is designed to be used with our ZR Plasmid Miniprep - Classic kit, which is used to efficiently isolate ultra-pure plasmid DNA from E. coli using Zymo-Spin column purification technology.",
			"handle": "/products/buffer-p3-yellow",
			"navigation_image": "https://files.zymoresearch.com/images/D4027-3-12_P3-Buffer-12-mL.jpg",
			"generalIndex": "998",
			"id": "buffer-p3-yellow",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"Cell-free Recovery Buffer": {
			"title": "Cell-free Recovery Buffer",
			"catalogNumbers": "R1072-3-20",
			"description": "A component for the Quick-cfDNA/cfRNA Serum & Plasma Kit",
			"handle": "/products/cell-free-recovery-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/R1072-3-20_Cell-free-Recovery-Buffer-20-mL.jpg",
			"generalIndex": "998",
			"id": "cell-free-recovery-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"ChIP DNA Binding Buffer": {
			"title": "ChIP DNA Binding Buffer",
			"catalogNumbers": "D5201-1-50, D5201-1-100",
			"description": "Used for binding of DNA recovered from a chromatin immunoprecipitation procedures onto a Zymo-Spin columns into a small elution volume.",
			"handle": "/products/chip-dna-binding-buffer",
			"navigation_image": "https://files.zymoresearch.com/images/D5201-1-50_ChIP-DNA-Binding-Buffer-10-mL.jpg",
			"generalIndex": "998",
			"id": "chip-dna-binding-buffer",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"DNA/RNA Buffer HT": {
			"title": "DNA/RNA Buffer HT",
			"catalogNumbers": "R2150-1-100",
			"description": "Used in the Quick-DNA/RNA HT kit and is a one-step lysis and binding reagent of DNA and total RNA from any biological or clinical sample",
			"handle": "/products/dna-rna-buffer-ht",
			"navigation_image": "https://files.zymoresearch.com/product-images/R2150-1-100.jpg",
			"generalIndex": "998",
			"id": "dna-rna-buffer-ht",
			"tags": [
				"buffers"
			],
			filters: []
		},
		"MagBinding Beads": {
			"title": "MagBinding Beads",
			"catalogNumbers": "D4100-2-12, D4100-2-16, D4100-2-24, D4100-2-3, D4100-2-6, D4100-2-8",
			"description": "MagBinding Beads for use with Zymo Research magnetic bead-based purification kits.",
			"handle": "/products/magbinding-beads",
			"navigation_image": "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
			"generalIndex": "998",
			"id": "magbinding-beads",
			"tags": [
				"magbeads"
			],
			filters: []
		},
		"Select-a-Size MagBead": {
			"title": "Select-a-Size MagBead",
			"catalogNumbers": "D4084-10, D4084-50",
			"description": "The Select-a-Size MagBeads selectively binds fragments based on the volume of buffer added relative to the sample.",
			"handle": "/products/select-a-size-magbead",
			"navigation_image": "https://files.zymoresearch.com/images/D4084-1-50_Select-A-Size-MagBeads-50-mL.jpg",
			"generalIndex": "998",
			"id": "select-a-size-magbead",
			"tags": [
				"magbeads"
			],
			filters: []
		},
		"ZymoBIOMICS MagBinding Beads": {
			"title": "ZymoBIOMICS MagBinding Beads",
			"catalogNumbers": "D4302-6-12, D4302-6-6",
			"description": "For use in ZymoBIOMICS magnetic bead-based purification kits. Sold individually or as part of the ZymoBIOMICS product line.",
			"handle": "/products/zymobiomics-magbinding-beads",
			"navigation_image": "https://files.zymoresearch.com/images/D4302-6-12_ZymoBIOMICS-MagBinding-Beads-12-ml.jpg",
			"generalIndex": "998",
			"id": "zymobiomics-magbinding-beads",
			"tags": [
				"magbeads"
			],
			filters: []
		},
		"MagBead J": {
			"title": "MagBead J",
			"catalogNumbers": "D4100-3-3, D4100-3-50, D4100-3-100",
			"description": "MagBead J is designed to seamlessly integrate with high-throughput automation systems, used as a reagent for nucleic acid, magnetic bead-based purification.",
			"handle": "/products/magbead-j",
			"navigation_image": "https://files.zymoresearch.com/images/D4100-2-6_MagBinding-Beads-6-ml.jpg",
			"generalIndex": "998",
			"id": "magbead-j",
			"tags": [
				"magbeads"
			],
			filters: []
		}

	}
}

/*

		"": {
			"title": "",
			"catalogNumbers": "",
			"description": "",
			"handle": "",
			"navigation_image": "",
			"generalIndex": "",
			"id": "",
			"tags": [
				"buffers",
			],
			filters: []
		},
*/